/**
 * THE PANE THAT ACTUALLY SCROLLS, walking up from a node.
 *
 * ⚠️ AND IT IS NOT THE WINDOW. The whole site lives inside `.scroll`, which carries
 * `overflow-y: auto`, so the document itself never moves an inch. An IntersectionObserver
 * left on its default root never fires here — not because the marker is too far down, but
 * because that pane CLIPS it, and a clipped target intersects nothing at all whatever
 * `rootMargin` claims. Measured before the fix: the marker sat 1265 px into a 1000 px
 * window with 1500 px of margin, and the observer stayed silent through five full scrolls.
 *
 * Found by walking rather than by naming `.scroll`, because a class name in a stylesheet
 * is not a promise, and this is the kind of breakage that shows up as "nothing happens".
 *
 * Shared by the album (its infinite scroll) and the information pages (their table of
 * contents follows the reading position): one walk, or two that drift.
 */
export function scrollingPane(node: Element): Element | null {
  for (let p = node.parentElement; p; p = p.parentElement) {
    const overflow = getComputedStyle(p).overflowY;
    if (overflow === "auto" || overflow === "scroll") return p;
  }
  return null;
}
